import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

const globalObject =
  (typeof window !== 'undefined' && window) ||
  (typeof global !== 'undefined' && global) ||
  undefined;

if (globalObject) {
  const currentProcess = globalObject.process;
  if (!currentProcess || typeof currentProcess !== 'object') {
    globalObject.process = { env: {} };
  } else if (typeof currentProcess.env !== 'object') {
    currentProcess.env = {};
  }
}

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
